import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classnames from 'classnames';

import View from '../../components/view/view';
import { userSdk } from '../../services/user.service';
import SuccessIcon from '../../assets/img/successful.svg';
import ResponseCodes from '../../constants/response.codes';

import styles from './password-recovery.module.scss';
import ChangePasswordForm from './containers/change-password-form';

const PasswordRecoveryView = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [apiResponseError, setApiResponseError] = useState({
        shown: false,
        message: '',
    });
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const token = params.get('token');
        if (!token) {
            navigate('/login');
        } else {
            checkToken(token);
        }
    }, []);

    const checkToken: (token: string) => void = useCallback(
        async (token: string) => {
            const response = await userSdk.checkPasswordToken(token);
            if (!response.data) {
                return navigate('/login');
            }
        },
        []
    );

    const hideApiMessage: () => void = useCallback(() => {
        setApiResponseError((prev) => ({ ...prev, shown: false }));
    }, [setApiResponseError]);

    const updatePassword: (password: string) => void = useCallback(
        async (password: string) => {
            setLoading(true);
            const response = await userSdk.changeOperatorPasswordByToken({
                token: params.get('token')!,
                password: password,
            });
            if (response.code !== ResponseCodes.PROCESS_OK) {
                setApiResponseError({
                    shown: true,
                    message: 'Error actualizando contraseña',
                });
                setTimeout(() => hideApiMessage(), 5000);
                return;
            }
            setSuccess(true);
        },
        []
    );

    return (
        <View menuSpace={false}>
            {success ? (
                <div className={styles.successContainer}>
                    <img
                        style={{ width: 200, height: 200 }}
                        src={SuccessIcon}
                        alt="password-successfully-changed"
                    />
                    <span>Contraseña actualizada exitosamente</span>
                    <span>Ya puedes cerrar esta ventana.</span>
                </div>
            ) : (
                <div className={styles.center}>
                    <h3>Actualizar contraseña</h3>
                    <ChangePasswordForm
                        loading={loading}
                        onUpdatePassword={updatePassword}
                    />
                    <div
                        className={classnames({
                            [styles.toast]: true,
                            [styles.shown]: apiResponseError.shown,
                        })}
                    >
                        <span>{apiResponseError.message}</span>
                    </div>
                </div>
            )}
        </View>
    );
};

export default PasswordRecoveryView;
